import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IGetDepartmentsArgs,
  IGetDepartmentsResponseData,
} from "./getDepartments.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IGetDepartmentsResponseData>;

export const getDepartments = (axios: IAxiosInstance) => {
  return async (params: IGetDepartmentsArgs) => {
    try {
      const response = await axios.noRetry.get<SuccessResponse>(
        `/api/departments`,
        {
          params,
        }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
